import { Card, Col, Row } from "react-bootstrap";
import Security from "components/settings/Security";

const SecuritySettings = () => {
  return (
    <Row>
      <Col xs={12} xl={12} xxl={8}>
        {/* <PageBreadcrumb items={settingsBreadcrumbItems} /> */}
        <div className="border-bottom border-translucent mb-7 mx-n3 px-2 mx-lg-n6 px-lg-6">
          <Row>
            <Col xl={9}>
              <div className="d-sm-flex justify-content-between">
                <h2 className="mb-4">Security Settings</h2>
              </div>
            </Col>
          </Row>
        </div>
        <Card className="p-4 mb-4">
          <Security />
        </Card>
      </Col>
    </Row>
  );
};

export default SecuritySettings;
